import { useEffect } from 'react';

// Forms with something typed but not saved. The back link and pop-ups ask
// before losing it; closing or reloading the tab gets the browser's warning.
const dirty = new Set();

const onBeforeUnload = (e) => {
  e.preventDefault();
  e.returnValue = '';
};

export function hasUnsavedChanges() {
  return dirty.size > 0;
}

/** useUnsavedChanges(form !== saved): marks this form while it's true */
export function useUnsavedChanges(isDirty) {
  useEffect(() => {
    if (!isDirty) return undefined;
    const token = {};
    dirty.add(token);
    if (dirty.size === 1) window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      dirty.delete(token);
      if (!dirty.size) window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, [isDirty]);
}
